import { createSlice } from '@reduxjs/toolkit';
// import { HYDRATE } from 'next-redux-wrapper';

const initialState = {
  query: '',
  categoryLabel: '',
  sortBy: '',
  queryInfinite: '',
  topNavSearchValue: '',
  successStoriesSearch: '',
  successStoriesSelectedValue: '',
  filterModalState: false,
  showAllCategory: false,
  startupLength: 0,
  scrollHeight: 0,
  isMarketingPage: false,
  mobileSeeAll: false,
  categoryData: {},
  raisingData: {},
  selectedTab: 0,
  searchMobileModalOpen: false,
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    updateSearchField: {
      reducer: (state, action) => {
        state[action.payload.key] = action.payload.value;
      },
    },
    clear: (state) => ({
      ...state,
      categoryLabel: '',
      sortBy: '',
    }),
  },
  // extraReducers: (builder) => {
  //   builder.addCase(HYDRATE, (state, action) => ({
  //     ...state,
  //     ...action.payload.search,
  //   }));
  // },
});

export const { updateSearchField, clear } = searchSlice.actions;

export default searchSlice.reducer;
